import { render } from "./AwardSummary.vue?vue&type=template&id=4b246160&scoped=true"
import script from "./AwardSummary.vue?vue&type=script&lang=js"
export * from "./AwardSummary.vue?vue&type=script&lang=js"

import "./AwardSummary.vue?vue&type=style&index=0&id=4b246160&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b246160"]])

export default __exports__